import { css } from "styled-components";

const BreakpointWidth = {
  xxs: [0, 399],
  xs: [400, 575],
  sm: [576, 767],
  md: [768, 991],
  lg: [992, 1199],
  xl: [1200, 3999],
};

export const Styling = {
  textColor: "#000",
  secondaryTextColor: "rgb(138, 143, 152)",

  primaryColor: "#5e6ad2",
  primaryBackgroundColor:
    "linear-gradient( 102deg,#4551b5 9.16%,#5643cc 32.02%,#543fd7 64.72% )",

  successColor: "#4caf50",
  blueColor: "#0967d2",
  dangerColor: "#d64545",
};

export const mediaBreakpointUp = (breakpoint) => `
  @media (min-width: ${BreakpointWidth[breakpoint][0]}px)
`;

export const mediaBreakpointDown = (breakpoint) =>
  `@media (max-width: ${BreakpointWidth[breakpoint][1]}px)`;

export const mediaBreakpointBetween = (
  breakpointLower,
  breakpointUpper,
  first,
  ...args
) => css`
  @media (min-width: ${BreakpointWidth[
  breakpointLower
  ][0]}px) and (max-width: ${BreakpointWidth[breakpointUpper][1]}px) {
    ${css(first, ...args)}
  }
`;
